export default "__VITE_ASSET__CBDmWoUF__"